import {BarycentricSlidersInput, type BarycentricCoordinates} from '@hconnect/uikit/src/lib2'

import type {OptimizerPriorities} from '../../../shared/interfaces/api'

import {
  mapBarycentricCoordinatesToOptimizerPriorities,
  mapOptimizerPrioritiesToBarycentricCoordinates,
  useOptimizerPrioritiesStyles
} from './optimizerPriorities.helpers'

interface OptimizerPrioritiesSlidersInputProps {
  value: OptimizerPriorities
  setValue: (value: OptimizerPriorities) => void
}

export const OptimizerPrioritiesSlidersInput: React.FC<OptimizerPrioritiesSlidersInputProps> = ({
  value,
  setValue
}) => {
  const styles = useOptimizerPrioritiesStyles()

  return (
    <BarycentricSlidersInput
      value={mapOptimizerPrioritiesToBarycentricCoordinates(value)}
      setValue={(coordinates: BarycentricCoordinates) => {
        setValue(mapBarycentricCoordinatesToOptimizerPriorities(coordinates))
      }}
      sliderConfig={styles}
    />
  )
}
